// extracted by mini-css-extract-plugin
export default {"form":"GenericPreload_form__a9pqC","recaptcha":"GenericPreload_recaptcha__MvGDd"};